import { createSelector } from 'reselect'
import { getAllOffers } from 'selectors/offerSelectors'
import { checkoutAccommodationOfferView, getLeAccommodationItems } from './view/accommodation'
import getBedbankItems from 'checkout/selectors/view/items/getBedbankItems'
import { isBedbankOffer, isLEHotel } from 'lib/offer/offerTypes'

export const SERENITY_ISLAND_FLASH_OFFER_ID = '006RF00000S5tgTYAR'
export const SHERATON_TOKORIKI_BEDBANK_PROPERTY_ID = '2397331d-9d1e-41af-80e9-b9d2bbc96ecd'

export const hasFijiHotelInCart = createSelector(
  (state: App.State) => getAllOffers(state),
  (state: App.State) => getLeAccommodationItems(state),
  (state: App.State) => getBedbankItems(state),
  (offers, leHotelItem, bedbankItems) => {
    const isFijiBedbank = bedbankItems.some(item => (offers[item.offerId] as App.BedbankOffer)?.property?.timezone === 'Pacific/Fiji') ?? false
    const isFijiHotel = leHotelItem.some(item => (offers[item.offerId] as App.HotelOffer)?.property?.timezone === 'Pacific/Fiji') ?? false

    return isFijiBedbank || isFijiHotel
  },
)

export const getFijiWaterTransferOffer = createSelector(
  (state: App.State) => checkoutAccommodationOfferView(state),
  (accommodationOfferViews): App.HotelOffer | App.BedbankOffer | undefined => {
    const matchingOffer = accommodationOfferViews.data
      .find(view =>
        ('propertyId' in view && view.propertyId === SHERATON_TOKORIKI_BEDBANK_PROPERTY_ID) ||
        (isLEHotel(view.offer) && view.offer.id === SERENITY_ISLAND_FLASH_OFFER_ID),
      )?.offer

    return isBedbankOffer(matchingOffer) || isLEHotel(matchingOffer) ? matchingOffer : undefined
  },
)

export const shouldShowFijiWaterTransferWarning = createSelector(
  (state: App.State) => getFijiWaterTransferOffer(state),
  (state: App.State) => state.checkout.cart.mode,
  (fijiOfferWithIncludedTransfer, cartMode) => !!fijiOfferWithIncludedTransfer && cartMode === 'default',
)
